<template >
  <div class="priceManagement-page">
    <div class="all-content-container">
      <div class="screen-all-container">
        <el-tabs v-model="activeName2" @tab-click="handleClick" class="el-tab_top" style="100% !important">
          <el-tab-pane label="设备告警配置" name="pane1">
            <deviceAlarm :message="activeName3"></deviceAlarm>
          </el-tab-pane>
          <el-tab-pane label="设备离线配置" name="pane2">
            <deviceOffline></deviceOffline>
          </el-tab-pane>
          <!-- <el-tab-pane label="比对告警配置" name="pane3">
            <alarmComparison></alarmComparison>
          </el-tab-pane> -->
          <el-tab-pane label="提醒用户配置" name="pane4">
            <alarmuser></alarmuser>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <div class="pagination-container">
      <div class="pagination-content-container"></div>
    </div>
  </div>
</template>
<script>
import deviceAlarm from '../alarmPrediction/deviceAlarm'
import deviceOffline from '../alarmPrediction/deviceOffline'
import alarmComparison from '../alarmPrediction/alarmComparison'
import alarmuser from '../alarmPrediction/alarmuser'

export default {
  name: 'alarmPredictions',
  components: {
    deviceAlarm,
    deviceOffline,
    alarmComparison,
    alarmuser
  },
  data() {
    return {
      activeName2: 'pane1',
      activeName3: 'pane3'
    }
  },
  created() {
    if (this.$route.query.currentShow) {
      this.activeName2 = this.$route.query.currentShow
    }
    if (this.$route.query.currentShow2) {
      this.activeName3 = this.$route.query.currentShow2
    }
  },
  methods: {
    handleClick() {}
  }
}
</script>
<style scoped>
.el-button {
  line-height: 0 !important;
}
.el-table {
  overflow: auto !important;
}
</style>